module.exports = __webpack_public_path__ + "static/img/7.9b9a7af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/7.png
// module id = FvNv
// module chunks = 0